import React from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Button, Dialog, DialogContent, Typography } from '@material-ui/core';
import { EVENT_ID, getUserID, USER_API_URL } from '../../constants';
import axios from 'axios';

import { BsGift } from 'react-icons/bs';

const moment = require('moment');
const styles = (theme) => ({
  liveDialogRoot: {
    '& .MuiDialog-paper': {
      [theme.breakpoints.up('md')]: {
        position: 'fixed !important',
        right: '25%',
        bottom: '0',
      },
    },
  },
  dialogContent: {
    textAlign: 'center',
    padding: theme.spacing(2, 3),
  },
  eventImg: {
    width: '100%',
  },
  eventText: {
    fontSize: '1.1rem',
    paddingTop: '0.7em',
    paddingBottom: '1em',
  },
  highlightText: {
    color: '#436c90',
    fontWeight: 700,
  },
  button: {
    width: '65%',
    // backgroundColor: '#436c90',
    // color: '#fff',
    fontSize: '1.3rem',
    fontWeight: 700,
    padding: '1.5vh 0',
    alignItems: 'center',
  },
});

class PrizeEventDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventStatus: null,
      refresh: false,
      url: '',
      todayDate: moment().format('YYYYMMDD'),
      firstDay: JSON.parse(sessionStorage.getItem('Item'))['startDate'],
      secondDay: JSON.parse(sessionStorage.getItem('Item'))['endDate'],
    };
  }

  eventPopup(eventUrl) {
    window.open(eventUrl, '_blank');
    const param = {
      evt: EVENT_ID,
      userid: getUserID(true),
    };

    if (this.props.eventTarget === '산학세션을 수강하신 30명') {
      param.eventType = `${this.state.todayDate}_live_checked`;
      localStorage.setItem(`${this.state.todayDate}_live_checked`, true);
    }
    // if (this.props.eventTarget === '5시간 이상 강의를 수강하신 2명') {
    //   param.eventType = `${this.state.todayDate}_5h_checked`;
    //   localStorage.setItem(`${this.state.todayDate}_5h_checked`, true);
    // }
    // if (this.props.eventTarget === '전체 강의를 수강하신 1명') {
    //   param.eventType = `${this.state.todayDate}_full_checked`;
    //   localStorage.setItem(`${this.state.todayDate}_full_checked`, true);
    // }

    axios.post(`${USER_API_URL}/user/prizeEvent`, param).then((res) => {});
    if (this.state.url !== '') {
      this.setState({ url: '' });
    }
    this.props.onClose();
  }

  render() {
    const { classes, eventTarget, eventImg, isLiveSession } = this.props;

    return (
      <Dialog
        className={isLiveSession ? classes.liveDialogRoot : classes.dialogRoot}
        onClose={this.props.onClose}
        open={this.props.open}
        fullWidth={true}
        maxWidth={'xs'}
      >
        <DialogContent className={classes.dialogContent}>
          <div>
            <img src={eventImg} className={classes.eventImg} alt="img" />
          </div>
          <div className={classes.eventText}>
            <span className={classes.highlightText}>{eventTarget}</span>을 추첨하여
            <br /> 소정의 상품을 드립니다.
            <br />
            아래의 버튼을 클릭하셔서 참여해주세요.
            {/* <br />
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              * 확인 버튼 클릭하여 해당 이벤트 당첨 시,
              <br /> 그 외 이벤트 응모에 제외됩니다.
            </span> */}
          </div>
          <div>
            {/* <Button fullWidth variant="contained" className={classes.button} disableElevation onClick={() => this.moveToEventPage()}> */}
            <Button
              variant="contained"
              fullWidth
              color={'primary'}
              className={classes.button}
              onClick={() => this.eventPopup(this.props.eventUrl)}
              startIcon={<BsGift />}
              // onClick={() => this.eventPopup(this.state.url !== '' ? this.state.url : this.props.eventUrl)}
            >
              <Typography>이벤트 페이지로</Typography>
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PrizeEventDialog);
